import { IAnnotation } from "dto/IAnnotation";
import { RefObject, createContext } from "react";

export interface IPDF {
  zoom: number;
  rotate: number;
  page: number;
  annotation: string | null;
  showAnnotation: string | null;
  canvas: RefObject<any> | null;
  editComment: string;
  annotationToAdd: IAnnotation | null;
  annotations: IAnnotation[];
  drawPin: boolean;
  drawLine: boolean;
  drawHighlight: boolean;
}

type IPDFContext = {
  PDF: IPDF;
  setPDF: (pdf: IPDF) => void;
};

export const DEFAULT_PDF_CONTEXT = {
  zoom: 1,
  page: 1,
  rotate: 0,
  annotation: null,
  showAnnotation: null,
  canvas: null,
  editComment: "",
  annotationToAdd: null,
  annotations: [],
  drawLine: false,
  drawPin: false,
  drawHighlight: false,
};

const PDFContext = createContext<IPDFContext>({
  PDF: DEFAULT_PDF_CONTEXT,
  setPDF: () => {},
});

export default PDFContext;
